import $ from 'jquery';
import ProductOptions from './ProductOptions';

export default class VariantHelper {
  constructor(product, $variants, $options) {
    this.product = product;
    this.optionsCount = this.product.options.length;
    this.$variants = $variants;
    this.$options = $options;
    this.productOptions = new ProductOptions(this.product);
    this.optionsTypes = {
      select: 'select',
      radio: 'input[type="radio"]',
    };

    this.$radioOptions = this.$options.filter((index, option) => $(option).is(this.optionsTypes.radio));
    this.$selectOptions = this.$options.filter((index, option) => $(option).is(this.optionsTypes.select));

    this._bindEvents();

    if (this.$radioOptions.length === 0 && this.$selectOptions.length === 0) {
      console.warn('Variant helper: Option set is not a valid type');
      this._unbindEvents();
      return;
    }

    this._switchVariant(true);
  }

  _bindEvents() {
    this.$options.on('change.variant-helper', event => this._switchVariant(false, event));
  }

  _unbindEvents() {
    this.$options.off('change.variant-helper');
  }

  _switchVariant(firstLoad = false, event) {
    const options = [];
    const product = this.product;
    const $currentTarget = event ? $(event.currentTarget) : null;
    let variant = null;
    let availableOptions = null;

    if (!$currentTarget || $currentTarget.is(this.optionsTypes.radio)) {
      this.$radioOptions.filter(':checked').each((index, option) => {
        options.push(option.value);
      });
    } else if ($currentTarget.is(this.optionsTypes.select)) {
      this.$selectOptions.each((index, option) => {
        options.push(option.value);
      });
    } else {
      return;
    }

    variant = this.productOptions.getVariant(options);

    if (variant) {
      availableOptions = this.productOptions.getValidOptions(variant);
    } else {
      return;
    }

    this._switchVariantSelect(variant, availableOptions);
    this._switchVariantRadio(variant, availableOptions);

    this.$variants.val(variant.id);
    $(window).trigger('product-variant-switch', { product, variant, firstLoad });
  }

  _switchVariantSelect(variant, availableOptions) {
    // Iterate over each option type
    for (let i = 0; i < this.product.options.length; i++) {
      // Corresponding select dropdown
      const $select = $(this.$selectOptions[i]);
      const $optionEls = $select.find('option');

      // Iterate over each option on dropdown
      $optionEls.each((index, option) => {
        const $option = $(option);
        const { value } = option;
        const isUnavailable = (!availableOptions[i][value] ||
          !availableOptions[i][value].available);

        // Not an available option
        $option
          .prop('disabled', isUnavailable)
          .prop('selected', false);

        // Dropdown option matches variant option
        if (variant.options[i] === value) {
          $option
            .prop('disabled', isUnavailable)
            .prop('selected', true);
        }
      });
    }
  }

  _switchVariantRadio(variant, availableOptions) {
    this.$radioOptions
      .attr('disabled', true)
      .prop('checked', false)
      .attr('data-soldout', false);

    for (let i = 0; i < this.product.options.length; i++) {
      const $options = this.$radioOptions.filter(`[name="${this.product.options[i]}"]`);
      $options.each((index, option) => {
        const $option = $(option);

        if (variant.options[i] === $option.val()) {
          $option
            .prop('checked', true)
            .attr('disabled', false);
        }

        if (availableOptions[i][$option.val()]) {
          $option.attr('disabled', false);

          if (!availableOptions[i][$option.val()].available) {
            $option.attr('data-soldout', true);
          }
        }
      });
    }
  }

  isDefault() {
    if (this.product.variants[0].title === 'Default Title' && this.product.variants[0].option1 === 'Default Title') {
      return true;
    }

    return false;
  }

  getSelectedVariant() {
    if (this.isDefault()) {
      return this.product.variants[0];
    }

    // Read selected options from the product form
    const options = [];

    this.$options.filter(':checked').each((index, option) => {
      options.push(option.value);
    });

    return this.productOptions.getVariant(options);
  }

  unload() {
    this._unbindEvents();
  }
}
